import { AnimatePresence } from 'framer-motion';
import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import AddExpenses from './pages/Account/AddExpenses.jsx';
import Allfees from './pages/Account/Allfees.jsx';
import Expenses from './pages/Account/Expenses.jsx';
import AddnewClasses from './pages/Class/AddnewClasses.jsx';
import AllClasses from './pages/Class/AllClasses.jsx';
import Admin from './pages/Dashboard/Admin.jsx';
import Parent from './pages/Dashboard/Parent.jsx';
import Student from './pages/Dashboard/Student.jsx';
import Teacher from './pages/Dashboard/Teacher.jsx';
import PageLayout from './Components/Layout/PageLayout.jsx';
import AddnewBook from './pages/Library/AddnewBook.jsx';
import AllBook from './pages/Library/AllBook.jsx';
import AddParent from './pages/Parents/AddParent.jsx';
import AllParent from './pages/Parents/AllParent.jsx';
import ParentDetail from './pages/Parents/ParentDetail.jsx';
import Admission from './pages/Students/Admission.jsx';
import Notice from './pages/Notice/Notice.jsx'
import Allstudent from './pages/Students/Allstudent.jsx';
import StudentDetail from './pages/Students/StudentDetail.jsx';
import StudentPromotion from './pages/Students/StudentPromotion.jsx';
import AddTeacher from './pages/Teacher/AddTeacher.jsx';
import AllTeachers from './pages/Teacher/AllTeachers.jsx';
import Payment from './pages/Teacher/Payment.jsx';
import TeacherDetails from './pages/Teacher/TeacherDetails.jsx';
import AccountSetting from './pages/AccountSetting/AccountSettings.jsx'
import Attendence from './pages/Attendence/Attendence.jsx';
import ClassRutine from './pages/ClassRoutine/ClassRutine.jsx';
import ExamGrades from './pages/Exam/ExamGrades.jsx'
import Login from './pages/Login/Login.jsx';
import Subject from './pages/Subject/Subject.jsx';
import PrivatesRoute from './Components/PrivatesRoute.jsx';

function App() {
  const location = useLocation();

  return (
    <>

      <div className="pages">
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>

            <Route path="/" element={<PageLayout />} >
              <Route path="admin" element={<Admin />} />
              <Route path="parent" element={<Parent />} />
              <Route path="student" element={<Student />} />
              <Route path="subject" element={<Subject />} />
              <Route path="teacher" element={<Teacher />} />
              <Route path="admission" element={<Admission />} />
              <Route path="allstudent" element={<Allstudent />} />
              <Route path="studentDetail" element={<StudentDetail />} />
              <Route path="studentPromotion" element={<StudentPromotion />} />
              <Route path="addTeacher" element={<AddTeacher />} />
              <Route path="allTeachers" element={<AllTeachers />} />
              <Route path="payment" element={<Payment />} />
              <Route path="teacherDetails" element={<TeacherDetails />} />
              <Route path="addParent" element={<AddParent />} />
              <Route path="allParent" element={<AllParent />} />
              <Route path="parentDetail" element={<ParentDetail />} />
              <Route path="addnewBook" element={<AddnewBook />} />
              <Route path="allBook" element={<AllBook />} />
              <Route path="addExpenses" element={<AddExpenses />} />
              <Route path="allfees" element={<Allfees />} />
              <Route path="expenses" element={<Expenses />} />
              <Route path="allClasses" element={<AllClasses />} />
              <Route path="addnewClasses" element={<AddnewClasses />} />
              <Route path="accountSetting" element={<AccountSetting />} />
              <Route path="attendence" element={<Attendence />} />
              <Route path="classRutine" element={<ClassRutine />} />
              <Route path="notice" element={<Notice />} />
              <Route path="examGrades" element={<ExamGrades />} />
            </Route>

            <Route path="login" element={<Login />} />
          </Routes>
        </AnimatePresence>
      </div>
    </>
  );
}

export default App;
